import { BuildNode, DropdownNode, NodeStates } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";

interface DropdownOptionProps {
    node: BuildNode;
    label: string;
    value: string;
    callback?: (value: string) => void;
    builder?: boolean;
    nodeState?: NodeStates;
    disabled?: boolean;
}

const DropdownOption = ({ node, label, value, callback, builder, nodeState, disabled }: DropdownOptionProps) => {
    const dNode = node as DropdownNode;
    const { stateManager, dropdownOptionStyle } = dNode;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    if (builder) {
        const style = getCompoundStyle({
            otherStyle: dropdownOptionStyle,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "dropdownOptionStyle")
        });

        return (
            <div className="dropdown-field-option" style={style}>
                {label}
            </div>
        );
    } else {
        const style = getStylesFromInteractiveStates({
            states,
            defaultStyle: dropdownOptionStyle,
            stateManager,
            paths: ["dropdownOptionStyle"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <div ref={setElement} className="dropdown-field-option" style={style} onClick={() => callback && callback(value)}>
                {label}
            </div>
        );
    }
};

export default DropdownOption;
